define('webshopProductsDetailBodyCategoriesTagsView',[
  'app',
  'module',
  'underscore',
  'tableFieldView',
  'template!webshopProductsDetailBodyCategoriesTagsView'
], function (
  App,
  Module,  
  _,
  FieldView,
  Tpl
) {
  'use strict';

  Module.exports = FieldView.extend({
    template: Tpl,
    className: 'webshop-products-detail-body-categories-tags-view ' + FieldView.prototype.className,

    serializeData: function() {
      var data = {};

      return data;
    }
  });
});
